import React, { useRef, useState } from "react";
import PropTypes from "kf-proptypes/widgets";
import { Trans } from "@lingui/macro";

import { Popover } from "../../feedback/index.jsx";
import {
  POPOVER_POSITIONS,
  POPOVER_TRIGGERS
} from "@widgets/feedback/popover/index.jsx";
import { ResetDialog } from "@widgets/inputs/index.jsx";
import {
  ICON_PADDING,
  ICON_SIZE,
  ICON_STROKE,
  KF_ICONS,
  KfIcon
} from "@widgets/common/components/primitives/kf_icon/index.jsx";

import styles from "./style.css";

export function PropertiesField({
  label,
  onReset,
  children,
  modified = false,
  inheritedFrom,
  showReset,
  showInherit,
  isInline = false,
  getPanelContainer,
  infoIcon = <></>
}) {
  const fieldRef = useRef();
  return (
    <div className={isInline ? styles.inline : styles.field} ref={fieldRef}>
      {label && (
        <div className={`tiny ${styles.label}`}>
          <label>{label}</label>
          {infoIcon}
          {showInherit && !modified && (
            <InheritDialog
              inheritedFrom={inheritedFrom}
              getPanelContainer={getPanelContainer}
            />
          )}
          {showReset && modified && (
            <ResetDialog
              inheritedFrom={inheritedFrom}
              getPanelContainer={getPanelContainer}
              onReset={onReset}
            />
          )}
        </div>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
}

PropertiesField.propTypes = {
  label: PropTypes.string.isRequired,
  inheritedFrom: PropTypes.string.isRequired,
  onReset: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  modified: PropTypes.bool,
  isInline: PropTypes.bool,
  showInherit: PropTypes.bool,
  showReset: PropTypes.bool,
  getPanelContainer: PropTypes.func,
  infoIcon: PropTypes.node
};

export function InheritDialog({ inheritedFrom, getPanelContainer }) {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Popover
      isOpen={isOpen}
      position={POPOVER_POSITIONS.BOTTOM_LEFT}
      targetRenderer={() => (
        <KfIcon
          icon={KF_ICONS.LINK}
          size={ICON_SIZE.SIZE_12}
          stroke={ICON_STROKE.THIN}
          onClick={() => setIsOpen(true)}
          className={styles.inheritIcon}
        />
      )}
      trigger={POPOVER_TRIGGERS.CLICK}
      {...(getPanelContainer && { getContainer: getPanelContainer })}
    >
      <div className={styles.resetDialog}>
        <div>
          <div className={styles.header}>
            <div className={styles.dialog}>
              <Trans>Value comes from </Trans>
              {" :"}
            </div>
            <KfIcon
              icon={KF_ICONS.CLOSE}
              size={ICON_SIZE.SIZE_12}
              stroke={ICON_STROKE.THIN}
              onClick={() => setIsOpen(false)}
              className={styles.closeIcon}
              padding={ICON_PADDING.PADDING_4}
            />
          </div>
          <div className={styles.propertyName}>{inheritedFrom}</div>
        </div>
      </div>
    </Popover>
  );
}
InheritDialog.propTypes = {
  inheritedFrom: PropTypes.string.isRequired,
  getPanelContainer: PropTypes.func
};
